import React from 'react'
import { useParams } from 'react-router-dom';
import { Button, Container } from 'reactstrap';
import { useAuth } from '../../Services/AuthContext';
import { useFetchEntity } from '../../Services/fetchApi';
import entities from '../../utils/entities';
import LoadingAnimation from '../Form/LoadingAnimation';
import DocumentDetails from '../Editors/DocumentDetails';

const SupplierInsuranceDocumentList = ({ route, supplierId: supp }: { route?: string, supplierId?: string }) => {
    const params = useParams<Record<"supplierId", string>>();
    const [auth] = useAuth();
    const supplierId = params.supplierId ?? auth.supplierId ?? supp;
    const [docs, loading, error, refresh] = useFetchEntity(entities.supplierInsuranceDocuments, { id: supplierId, status: 'Active' });
    //const [optionalDocs, oloading, oerror, orefresh] = useFetchEntity(entities.supplierOptionalDocument, { id: supplierId, status: 'Active' });

    return <Container style={{ overflowY: 'scroll', height: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', flexWrap: 'wrap' }}>
            <h3 style={{ margin: 0 }}>Aviation Hull</h3>
            <h5 style={{ margin: 0, color: 'red' }}>If you have more than one policy please merge to one document.</h5>
        </div>
        {loading ? <LoadingAnimation /> : error ? <h3>Error<Button onClick={() => refresh}>Retry</Button></h3> : null}
        {docs && docs.filter(doc => doc.documentCategory === "Aviation Hull").map((doc, i) => <DocumentDetails key={i} doc={doc} refresh={refresh} supplierId={supplierId} />)}

        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', flexWrap: 'wrap' }}>
            <h3 style={{ margin: 0 }}>Aviation Third Party Liability</h3>
            <h5 style={{ margin: 0, color: 'red' }}>If you have more than one policy please merge to one document.</h5>
        </div>
        {loading ? <LoadingAnimation /> : error ? <h3>Error<Button onClick={() => refresh}>Retry</Button></h3> : null}
        {docs && docs.filter(doc => doc.documentCategory === "Aviation Third Party Liability").map((doc, i) => <DocumentDetails key={i} doc={doc} refresh={refresh} supplierId={supplierId} />)}
        <h3>Product Liability</h3>
        {loading ? <LoadingAnimation /> : error ? <h3>Error<Button onClick={() => refresh}>Retry</Button></h3> : null}
        {docs && docs.filter(doc => doc.documentCategory === "Product Liability").map((doc, i) => <DocumentDetails key={i} doc={doc} refresh={refresh} supplierId={supplierId} />)}
        <h3>Public Liability</h3>
        {loading ? <LoadingAnimation /> : error ? <h3>Error<Button onClick={() => refresh}>Retry</Button></h3> : null}
        {docs && docs.filter(doc => doc.documentCategory === "Public Liability").map((doc, i) => <DocumentDetails key={i} doc={doc} refresh={refresh} supplierId={supplierId} />)}
        <h3>Workers Compensation</h3>
        {loading ? <LoadingAnimation /> : error ? <h3>Error<Button onClick={() => refresh}>Retry</Button></h3> : null}
        {docs && docs.filter(doc => doc.documentCategory === "Workers Compensation").map((doc, i) => <DocumentDetails key={i} doc={doc} refresh={refresh} supplierId={supplierId} />)}
        <h3>Optional Documents</h3>
        {loading ? <LoadingAnimation /> : error ? <h3>Error<Button onClick={() => refresh}>Retry</Button></h3> : null}
        {docs && docs.filter(doc => doc.documentCategory === "Optional Documents").map((doc, i) => <DocumentDetails optional key={i} doc={doc} refresh={refresh} supplierId={supplierId} />)}
        {/* {oloading ? <LoadingAnimation /> : oerror ? <h3>Error<Button onClick={() => orefresh}>Retry</Button></h3> : null}
        {optionalDocs?.map((doc, i) => <DocumentDetails optional key={i} doc={doc} refresh={orefresh} supplierId={supplierId} />)} */}
    </Container>

}

export default SupplierInsuranceDocumentList;


